"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDisplayRoundNumber_1 = __importDefault(require("./getDisplayRoundNumber"));
function getRoundNumber(value, rounding) {
    return Number(getDisplayRoundNumber_1.default(value, rounding));
}
exports.default = getRoundNumber;
//# sourceMappingURL=getRoundNumber.js.map